import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ProcessMappingCriteria extends BasicCriteria {
inField: string;
visionCode: string;
}

